/**
 * @generated SignedSource<<0f11b4329fe9962b92d05ced5c2a7afd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductStatusEnum = "active" | "inactive" | "ongoing" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductStatusLabel_product$data = {
  readonly status: ProductStatusEnum;
  readonly " $fragmentType": "ProductStatusLabel_product";
};
export type ProductStatusLabel_product$key = {
  readonly " $data"?: ProductStatusLabel_product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductStatusLabel_product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductStatusLabel_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "823aba102447ab723038ad4082d8ae39";

export default node;
